import { render, staticRenderFns } from "./SingerSelect.vue?vue&type=template&id=43873c51&"
import script from "./SingerSelect.vue?vue&type=script&lang=js&"
export * from "./SingerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports